import { useToast } from "@chakra-ui/react";
import { extractErrorMessage } from "@equidefi/portals";
import { useCreateInvestment } from "@equidefi/portals/hooks/useInvestments";
import { investmentBcode, offeringInactiveWarning, offeringIsActive } from "@equidefi/shared";
import { BannerAlert, Text } from "@equidefi/ui";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router";
import { WorkflowContainer } from "../WorkflowContainer";
import "./auth.css";

const ExistInvestorRegister = ({ offering }) => {
  const navigate = useNavigate();
  const [cookies] = useCookies(["bcode", `ref_${offering?.slug}`]);
  const createInvestment = useCreateInvestment();
  const toast = useToast();

  const isOfferingNotActive = offering?.status && !offeringIsActive(offering);
  const inactiveWarning = offeringInactiveWarning(offering);

  const onInvest = async () => {
    try {
      const response = await createInvestment.mutateAsync({
        offering_id: offering.id,
        bcode: investmentBcode(cookies?.bcode),
        ref: cookies?.[`ref_${offering?.slug}`],
      });
      navigate(`/offerings/${offering.slug}/${response.id}/profile`);
    } catch (error) {
      console.error(error);
      toast({
        status: "error",
        description: extractErrorMessage(error),
      });
      if (error?.response?.status === 409) {
        navigate(`/offerings/${offering.slug}/choose`);
      }
    }
  };

  return (
    <WorkflowContainer
      title={`Welcome to ${offering.issuer.name}'s offering!`}
      buttonProps={{ isLoading: createInvestment.isLoading, isDisabled: isOfferingNotActive }}
      onContinue={onInvest}
      buttonLabel="Start Investment">
      <Text>Thank you for your interest in {offering.issuer.name}</Text>

      {inactiveWarning && <BannerAlert status="warning" my={4} description={inactiveWarning} />}

      <Text textStyle="body2" mt={8} mb={12} align="center" fontWeight="bold">
        We see you are already logged in, click &quot;Start Investment&quot; to begin.
      </Text>
    </WorkflowContainer>
  );
};

export default ExistInvestorRegister;
